import {StateProvider} from "@uirouter/angularjs";
import {UserConfigProvider} from "../types/UserConfig";
import {TradingSystemsService} from "./service/TradingSystemsService";
import {TradingSystemsViewStore} from "./service/TradingSystemsViewStore";
import {LocalStorageService} from "../types/NgStorage";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {
    $stateProvider.state("tradingSystems", {
        url: "/trading-systems",
        component: "tradingSystemsView",
        data: {
            pageTitle: "Trading Scans"
        },
        resolve: {
            viewStore: viewStoreResolver
        },
        onEnter: () => userConfigProvider.config.features.SCREEN_TRADING_SYSTEMS,
        onExit: tearDownHook
    });
}

/** @ngInject */
export function viewStoreResolver(tradingSystemsService: TradingSystemsService,
                                  $localStorage: LocalStorageService): TradingSystemsViewStore {
    return new TradingSystemsViewStore(tradingSystemsService, $localStorage);
}

/** @ngInject */
export function tearDownHook(viewStore: TradingSystemsViewStore) {
    viewStore.dispose();
}
